import { render, staticRenderFns } from "./NbRadioGroupOption.vue?vue&type=template&id=4f45dae6&scoped=true&"
import script from "./NbRadioGroupOption.vue?vue&type=script&lang=js&"
export * from "./NbRadioGroupOption.vue?vue&type=script&lang=js&"
import style0 from "./NbRadioGroupOption.vue?vue&type=style&index=0&id=4f45dae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45dae6",
  null
  
)

export default component.exports